import {KeyboardEvent as ReactKeyboardEvent} from 'react';

export function isActivationKey(key: string): boolean {
    return key === 'Enter' || key === ' ';
}

export function handleActivationKey(event: ReactKeyboardEvent, onActivate: () => void): void {
    if (!isActivationKey(event.key)) {
        return;
    }

    event.preventDefault();
    onActivate();
}

export function getActivatableProps(
    onActivate: () => void,
    options?: {disabled?: boolean; role?: string; ariaLabel?: string}
) {
    const disabled = options?.disabled ?? false;

    return {
        role: options?.role ?? 'button',
        tabIndex: disabled ? -1 : 0,
        'aria-disabled': disabled || undefined,
        'aria-label': options?.ariaLabel,
        onClick: () => {
            if (!disabled) {
                onActivate();
            }
        },
        onKeyDown: (event: ReactKeyboardEvent) => {
            if (!disabled) {
                handleActivationKey(event, onActivate);
            }
        }
    };
}
